import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft, FileText } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="page-container pt-6 space-y-6">
      <Link to="/">
        <Button variant="ghost" className="mb-2">
          <ArrowLeft className="w-5 h-5 mr-2" />
          Volver
        </Button>
      </Link>

      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
          <FileText className="w-6 h-6 text-primary" />
        </div>
        <h1 className="heading-2">Términos y Condiciones</h1>
      </div>

      <Card className="card-base">
        <CardContent className="p-6 space-y-6 text-sm leading-relaxed">
          <p className="text-muted-foreground">
            Bienvenido a Tu Prima. Al usar nuestra plataforma, aceptas estas condiciones. 
            Las escribimos en lenguaje humano para que las entiendas fácil.
          </p>

          <div>
            <h3 className="font-semibold text-lg mb-2">1. ¿Qué es Tu Prima?</h3>
            <p className="text-muted-foreground">
              Tu Prima es una plataforma digital de sorteos promocionales. Compras tickets, 
              participas en sorteos y puedes ganar premios en efectivo. Así de simple.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">2. El precio del ticket</h3>
            <p className="text-muted-foreground">
              Cada ticket tiene un valor de <strong>$2.500 COP</strong>. Este precio puede cambiar 
              en el futuro, pero siempre te avisaremos antes de cualquier cambio.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">3. ¿Cómo funcionan los sorteos?</h3>
            <p className="text-muted-foreground">
              Los sorteos se realizan de forma automática cuando la barra de progreso llega al 100%. 
              No hay hora fija. Puede haber varios sorteos el mismo día. Cuando se completa, 
              el sorteo se ejecuta en máximo 3 minutos.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">4. Los premios</h3>
            <ul className="text-muted-foreground space-y-1 list-disc list-inside">
              <li><strong>$1.000.000</strong> - Premio Mayor (número ganador)</li>
              <li><strong>$200.000</strong> - Número Invertido (si gana 123, gana quien tenga 321)</li>
              <li><strong>$100.000</strong> - Top Buyer (quien más tickets compró)</li>
            </ul>
            <p className="text-muted-foreground mt-2">
              Los premios se entregan al usuario ganador registrado. No son acumulables entre sorteos.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">5. Puedes comprar varios tickets</h3>
            <p className="text-muted-foreground">
              Un usuario puede comprar todos los tickets que quiera. Entre más compres, 
              más oportunidades tienes de ganar. Cada ticket es una oportunidad.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">6. Probabilidades</h3>
            <p className="text-muted-foreground">
              Cada ticket tiene la misma probabilidad de ganar. No hay números "mejores" que otros. 
              El sistema es automático y aleatorio. Si compras más tickets, tu probabilidad aumenta 
              proporcionalmente.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">7. Al participar, aceptas todo esto</h3>
            <p className="text-muted-foreground">
              Cuando compras un ticket, aceptas todas estas condiciones. Si no estás de acuerdo, 
              no uses la plataforma.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">8. Podemos actualizar las reglas</h3>
            <p className="text-muted-foreground">
              La plataforma puede actualizar estas reglas para mejorar la experiencia. 
              Siempre te avisaremos cuando haya cambios importantes.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">9. Uso indebido</h3>
            <p className="text-muted-foreground">
              El uso indebido de la plataforma (fraude, bots, cuentas falsas) puede resultar 
              en bloqueo de cuenta sin derecho a reclamo.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">10. No garantizamos ganancias</h3>
            <p className="text-muted-foreground">
              Tu Prima no garantiza ganancias, solo participación justa. Esto es un sorteo, 
              no una inversión. Participa de forma responsable.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">11. Contacto</h3>
            <p className="text-muted-foreground">
              Si tienes preguntas, escríbenos a{' '}
              <a href="mailto:contacto@tuprima.com" className="text-primary hover:underline">
                contacto@tuprima.com
              </a>
            </p>
          </div>

          <div className="pt-4 border-t">
            <p className="text-xs text-muted-foreground text-center">
              Última actualización: Enero 2025
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
